import { isDebug } from "@/utils/commonUtils";

// 中升一级分销商 ID 列表（零售商的一级上级命中其一即可）
export const ZHONG_SHENG_DISTRIBUTOR_ID = isDebug()
  ? ["202509051333552569200000"]
  : [
      "202607220718427206120000",
      "202607160358086662090000",
      "202607100121236946860000",
      "202607060412214926860000",
      "202607060403198436860000",
    ];
